import { l } from '@manychat/manyui'

import { ExternalTriggerType } from 'apps/externalTriggers/externalTriggerConstants'
import { IExternalTrigger } from 'apps/externalTriggers/externalTriggerInterfaces'
import {
  ConverterRule,
  TriggersConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { FlowChartTrigger } from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'
import {
  getHotmartAbandonedCartTriggerCaption,
  getHotmartPurchaseChangeTriggerCaption,
} from 'utils/lib/getHotmartTriggerData'

import { ExternalTriggerGenericTriggerConverterRule } from './ExternalTriggerGenericTriggerConverterRule'

export const HotmartGenericTriggerConverterRule: ConverterRule<
  IFlowTrigger,
  FlowChartTrigger,
  TriggersConverterRulePayload
> = {
  predicate: (entity: IFlowTrigger) =>
    entity?.triggerType === TriggerType.EXTERNAL_TRIGGER &&
    (entity?.externalTriggerType === ExternalTriggerType.HOTMART_ABANDONED_CART ||
      entity?.externalTriggerType === ExternalTriggerType.HOTMART_POST_PURCHASE_CHANGE_STATUS),
  convert: (entity: IExternalTrigger, { state }) => {
    const genericTriggerData = ExternalTriggerGenericTriggerConverterRule.convert(entity, { state })

    if (!genericTriggerData) {
      return null
    }

    const captionData = {
      title: genericTriggerData.title,
      subtitle: genericTriggerData.subtitle,
    }

    if (entity.externalTriggerType === ExternalTriggerType.HOTMART_POST_PURCHASE_CHANGE_STATUS) {
      captionData.title = l.translate('Customer changes payment status')
      captionData.subtitle = [getHotmartPurchaseChangeTriggerCaption(entity)]
    } else if (entity.externalTriggerType === ExternalTriggerType.HOTMART_ABANDONED_CART) {
      captionData.title = l.translate('Customer abandons their cart')
      captionData.subtitle = [getHotmartAbandonedCartTriggerCaption(entity)]
    }

    return {
      ...genericTriggerData,
      ...captionData,
    }
  },
}
